<template>
  <post-code-typeahead
      v-if="hasPostCodeSearchProvider && hasTypeahead && hasAutocompletePostCode" :model="model" :attribute="attribute"
      :rules="rules" :disabled="disabled" @onChangeAddressInfo="setModelInfo" @keyup="toUpper">
  </post-code-typeahead>
  <input-widget
      v-else-if="hasPostCodeSearchProvider && hasAutocompletePostCode" :model="model" :attribute="attribute"
      :disabled="disabled" :rules="rules" @keyup="toUpper" @input="getCollectionInfo">
  </input-widget>
  <input-widget v-else :model="model" :attribute="attribute" :disabled="disabled" :rules="rules" @keyup="toUpper"/>
</template>

<script>
  import PostCodeTypeahead from "./PostCodeTypeahead";
  import InputWidget from "../components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";
  import _ from "lodash";
  import {PostCodeHelperService} from "../services/postCodeHelper.service";

  const {mapState} = createNamespacedHelpers('global');
  export default {
    name: "PostCodeInputWidget",
    components: {InputWidget, PostCodeTypeahead},
    props: {
      model: {
        type: Object,
        required: true
      },
      attribute: {
        type: String,
        required: true
      },
      rules: {
        type: [String, Object],
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      },
      src: {
        type: String,
        default: null
      },
    },
    computed: {
      ...mapState(['postCodeProviderInfo']),
      hasPostCodeSearchProvider() {
        return this.postCodeProviderInfo.has_search_provider;
      },
      hasTypeahead() {
        return this.postCodeProviderInfo.has_typeahead;
      },
      autocompletePostCodeForms() {
        return this.postCodeProviderInfo.autocomplete_post_code_forms;
      },
      hasAutocompletePostCode() {
        return this.autocompletePostCodeForms.includes(this.src);
      },
    },
    methods: {
      toUpper(e) {
        this.model[this.attribute] = e.target.value.toUpperCase();
      },
      getCollectionInfo: _.debounce(async function (value) {
        const {success, body} = await PostCodeHelperService.getInfoByPostCode({post_code: value.trim()});
        if (success) {
          if (Object.keys(body).length) {
            this.setModelInfo(body)
          }
        } else if (body.non_field_errors) {
          this.$errorDialog(body.non_field_errors[0]);
        }
      }, 500),
      setModelInfo(params) {
        const data = params[this.src];
        for (let field in data) {
          this.model[field] = data[field];
        }
      },
    }
  }
</script>

<style scoped>

</style>